import { render } from "./CurrencyExchangeRate.vue?vue&type=template&id=12c7c178&ts=true"
import script from "./CurrencyExchangeRate.vue?vue&type=script&lang=ts"
export * from "./CurrencyExchangeRate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__